import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        themes: {
            light: {
                primary: '#bbbf32',
                attention: '#ba0938',
                secondary: '#525d63',
                accent: '#ccc',
                trackColor: '#ccc',
                grey: '#ccc'
            },
        },
        options: {
            customProperties: true,
        },
    },
});
